// extracted by mini-css-extract-plugin
export var buttons = "bh_cp";
export var container = "bh_h";
export var content = "bh_cf";
export var icon = "bh_bw";
export var iconContainer = "bh_bX";
export var image = "bh_k";
export var section = "bh_j";
export var selected = "bh_bg";
export var tab = "bh_dV";
export var tabText = "bh_dT";